/* "Only N left in stock" (snippets/am-stock-left.liquid prints the starting number).
   Remembers each product's number per visitor so its card and its page agree, keeps neighbouring
   cards from showing the same number, and ticks the numbers down while the page is open. */
(function () {
  var KEY = 'am_stock_v1', LO = 3, HI = 14, FLOOR = 2, DROPS = 4;
  var els = Array.prototype.slice.call(document.querySelectorAll('[data-am-stock]'));
  if (!els.length) return;
  var db = {};
  try { db = JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) {}
  function save() { try { localStorage.setItem(KEY, JSON.stringify(db)); } catch (e) {} }

  var now = Date.now(), byHandle = {}, recent = [];
  els.forEach(function (el) {
    var h = el.getAttribute('data-am-stock');
    if (byHandle[h]) { byHandle[h].push(el); return; }
    byHandle[h] = [el];
    var base = parseInt(el.getAttribute('data-n'), 10) || LO, r = db[h];
    if (!r) {
      var n = base;
      for (var k = 0; k <= HI - LO && recent.indexOf(n) > -1; k++) n = n >= HI ? LO : n + 1;
      r = db[h] = { n: n, b: base, f: Math.max(FLOOR, n - DROPS), t: now };
    } else if (now - r.t > 9e5 && r.n > r.f) { r.n--; r.t = now; }   // back after 15+ min: one sold meanwhile
    if (base < r.b) { r.b = base; r.n = Math.min(r.n, base); r.f = Math.min(r.f, r.n); }   // real stock went lower
    recent.push(r.n); if (recent.length > 3) recent.shift();
  });
  save();

  function paint(h, pop) {
    var n = db[h].n;
    byHandle[h].forEach(function (el) {
      el.textContent = n;
      if (pop) { el.classList.remove('is-drop'); void el.offsetWidth; el.classList.add('is-drop'); }
    });
    document.querySelectorAll('[data-am-stock-bar="' + h + '"] span').forEach(function (s) { s.style.width = Math.min(90, n * 6) + '%'; });
  }
  Object.keys(byHandle).forEach(function (h) { paint(h, false); });

  var main = document.querySelector('[data-am-stock-main]');
  main = main && main.getAttribute('data-am-stock');
  function inView(el) { var b = el.getBoundingClientRect(); return b.height > 0 && b.bottom > 0 && b.top < window.innerHeight; }
  function tick() {
    if (!document.hidden) {
      var pool = (main ? [main] : Object.keys(byHandle).filter(function (h) { return byHandle[h].some(inView); }))
        .filter(function (h) { return db[h].n > db[h].f; });
      if (pool.length) {
        var h = pool[Math.floor(Math.random() * pool.length)];
        db[h].n--; db[h].t = Date.now(); save(); paint(h, true);
      }
    }
    setTimeout(tick, main ? 35e3 + Math.random() * 40e3 : 12e3 + Math.random() * 14e3);
  }
  setTimeout(tick, main ? 8e3 + Math.random() * 10e3 : 6e3 + Math.random() * 6e3);
})();
